<template>
  <div class="category">
    <Search @getCatId="getCatId" :catId="catId"/>
    <div class="content">
      <Brands :brands="brands" :brandId="brandId" @getBrandId="getBrandId"/>
      <Product :products="results" @getMoreProductList="getMoreProductList"/>
    </div>
  </div>
</template>
<style scoped>
.category {
  width: 3.75rem;
  height: 100vh;
  /* overflow: hidden; */
}
.content {
  padding: 0.9rem 0 0 0;
  display: flex;
}
</style>
<script>
import Search from "@/components/Mobile/Category/Search";
import Brands from "@/components/Mobile/Category/Brands";
import Product from "@/components/Mobile/Category/Product";
export default {
  components: {
    Search,
    Brands,
    Product
  },
  data() {
    return {
      catId: 1,
      size: 20,
      brandId: 0,
      results: [],
      page: -1
    };
  },
  computed: {
    brands() {
      return this.$store.state.oldproduct.products.brands;
    },
    products() {
      return this.$store.state.oldproduct.products.products;
    }
  },
  mounted: function() {
    if(this.$route.query.referer){
      localStorage.referer = this.$route.query.referer
    }
    if(this.$route.query.code){
      localStorage.parent_id = this.$route.query.code
    }
    let catId = this.$route.query.catId;
    let brandId = this.$route.query.brandId;
    if(catId){
      this.catId = catId
    }
    if(brandId){
      this.brandId = brandId
    }
  },
  methods: {
    getCatId(id) {
      this.catId = id;
      this.brandId = 0;
      this.page = 1;
      this.results = [];
       scrollTo(0,0);
      this.getProductList();
    },
    getBrandId(id) {
      this.brandId = id;
      this.page = 1;
      this.results = [];
       scrollTo(0,0);
      this.getProductList();
    },
    getProductList() {
      // this.results = [];
      // Indicator.open("loading ...");
      this.$toast.loading("加载中...");
      let params = {
        catId: this.catId,
        size: this.size,
        brandId: this.brandId,
        page: this.page
      };
      this.$store.dispatch("oldproduct/fetchProductList", { params }).then(() => {
        this.results = this.results.concat(
          this.$store.state.oldproduct.products.products
        );
        this.$toast.clear();
        // Indicator.close();
      });
    },
    getMoreProductList() {
      this.page = this.page + 1;
      this.getProductList();
    }
  },
  created() {
    this.getProductList();
  }
};
</script>
